import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ResetPasswordPopup from "./reset-password-popup";
import { routes } from "../../../constants/routes";

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token") || "";

  return (
    <ResetPasswordPopup
      open={true}
      token={token}
      onClose={() => navigate(routes.PROVIDER_LOGIN)}
      onSuccess={() => navigate(routes.PROVIDER_LOGIN)}
    />
  );
};

export default ResetPasswordPage;
